import { Box } from 'src/design/atoms/Box';
import { Group } from 'src/design/atoms/Group';
import React from 'react';
import { JobUserDto, UserDto } from 'src/api/FiretrolApiClient';
import { useAddTeamMember } from 'src/api/queries/jobs/useJobMutations';
import { UserSelect } from 'src/app/selectors/UserSelect';
import { getErrorMessage } from 'src/utils';
import { useJobs } from 'src/hooks/useJobs';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { CreateButton } from 'src/design/atoms/CreateButton';

interface ITeamMemberSelector {
  existingUsers: JobUserDto[];
}

export const TeamMemberSelector: React.FC<ITeamMemberSelector> = ({
  existingUsers,
}) => {
  const { selectedJob } = useJobs();
  const addTeamMember = useAddTeamMember();
  const [showSelector, setShowSelector] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [userToAdd, setUserToAdd] = React.useState<UserDto | null>(null);

  const filterUserData = (options: UserDto[]) => {
    return options.filter(
      (o) => !existingUsers.find((user) => user.userId === o.id),
    );
  };

  const addUserToTeam = async () => {
    if (!selectedJob || !userToAdd) return;
    setError(null);
    try {
      await addTeamMember.mutateAsync({
        jobId: selectedJob.id,
        userId: userToAdd.id,
      });
      setShowSelector(false);
      setUserToAdd(null);
    } catch (err) {
      setError(getErrorMessage(err));
    }
  };
  const resetSelector = () => {
    setShowSelector(false);
    setUserToAdd(null);
  };
  return (
    <Group>
      {showSelector ? (
        <>
          <Box w={300}>
            <UserSelect
              onChange={(user) => setUserToAdd(user)}
              value={userToAdd}
              hideLabel
              dataFilter={filterUserData}
            />
          </Box>
          <BasicButton
            color="black"
            variant="subtle"
            loading={addTeamMember.isPending}
            onClick={resetSelector}
          >
            Cancel
          </BasicButton>
          <CreateButton
            loading={addTeamMember.isPending}
            onClick={addUserToTeam}
            disabled={!userToAdd}
          >
            Add To Team
          </CreateButton>
          {error && <p>{error}</p>}
        </>
      ) : (
        <CreateButton onClick={() => setShowSelector(true)}>
          Add Team Member
        </CreateButton>
      )}
    </Group>
  );
};
